import { apiEmpleo } from "../../util/ApiEmpleo";

export type TGetContactsResponse = {
  id: string;
  Business_Country?: string;
  C_digo_Postal?: string;
  Email?: string;
  First_Name?: string;
  Last_Name?: string;
  Lead_Source?: string;
  Parentesco?: string;
  Phone?: string;
  zohoId?: string;
};

export interface IApiGetContacts {
  itemsPerPage?: number;
  searchFor?: string;
  page?: number;
}

const apiGetContacts = async (params: IApiGetContacts) => {
  let res = await apiEmpleo.get("contacts", { params });

  return res;
};

export { apiGetContacts };
